<script lang="ts">
  import { activeTab, settingsOpen, type TabId } from '../lib/stores';
  import { t as tr } from '../lib/i18n';

  type Tab = { id: TabId; label: string; path: string };
  // Icon-only top bar. Single-path SVGs (stroke = currentColor) so they theme.
  const tabs: Tab[] = [
    { id: 'dashboard',  label: 'Dashboard',  path: 'M4 13h7V4H4v9zm0 7h7v-5H4v5zm9 0h7v-9h-7v9zm0-16v5h7V4h-7z' },
    { id: 'profile',    label: 'Wellness',   path: 'M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6c-2.5 4.5-9.5 9-9.5 9z' },
    { id: 'labs',       label: 'Labs',       path: 'M9 3h6M10 3v6.5L5.2 18a2 2 0 0 0 1.8 3h10a2 2 0 0 0 1.8-3L14 9.5V3' },
    { id: 'imaging',    label: 'Imaging',    path: 'M3 5h18v14H3zM3 9h18M8 5v4M8 14l3 3 5-6' },
    { id: 'procedures', label: 'Procedures', path: 'M14.5 3.5l6 6M16 2l6 6-9.5 9.5-6-6zM7 13l-4 8 8-4' },
    { id: 'notes',      label: 'Notes',      path: 'M5 3h10l4 4v14H5zM15 3v4h4M8 12h8M8 16h6' },
  ];
</script>

<nav class="tabbar" aria-label="Primary">
  {#each tabs as t (t.id)}
    <button
      class="tab"
      class:on={$activeTab === t.id}
      aria-label={$tr('nav.' + t.id)}
      aria-current={$activeTab === t.id ? 'page' : undefined}
      title={$tr('nav.' + t.id)}
      onclick={() => { activeTab.set(t.id); settingsOpen.set(false); }}
    >
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
           stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
        <path d={t.path} />
      </svg>
    </button>
  {/each}
</nav>

<style>
  .tabbar {
    display: grid;
    grid-template-columns: repeat(6, 1fr);
    gap: var(--space-1);
    padding: var(--space-2) var(--space-3);
    background: var(--bg);
    border-bottom: 1px solid var(--line);
    z-index: var(--z-nav);
  }
  .tab {
    display: grid;
    place-items: center;
    padding: var(--space-2) 0;
    border-radius: var(--radius-sm);
    color: var(--text-3);
    position: relative;
    transition: color var(--ease), background var(--ease);
  }
  .tab svg { width: 23px; height: 23px; }
  .tab:hover { color: var(--text-2); background: var(--surface-2); }
  .tab.on { color: var(--accent); }
  /* active underline accent */
  .tab.on::after {
    content: '';
    position: absolute;
    bottom: -1px;
    left: 22%;
    right: 22%;
    height: 2px;
    border-radius: var(--radius-pill);
    background: var(--accent-grad);
  }
</style>
